module.exports = __webpack_public_path__ + "img/astroCalendar_mobile.8bcca818.svg";